import React from 'react';
import { Route } from 'react-router-dom';

import WidgetAuthenticationLayer from './WidgetAuthenticationLayer';

import { WIDGET_BASE_PATH } from '../../constants/paths';

const WidgetLayout = (props) => {
  return (
    <Route path={WIDGET_BASE_PATH} component={WidgetAuthenticationLayer}/>
  );
}

export default WidgetLayout;
